import React, { useState } from "react"

const ROLE_CONFIG = {
  user:   { align: "items-end",   bubble: "bg-admin_primary text-admin_text_inv rounded-2xl rounded-br-sm", label: "You" },
  agent:  { align: "items-start", bubble: "bg-admin_secondary/15 text-admin_text rounded-2xl rounded-bl-sm", label: "Agent" },
  system: { align: "items-start", bubble: "bg-admin_warning/10 border border-admin_warning/30 text-admin_text rounded-lg w-full text-xs", label: "System" }
}

function FnCallBadge({ data }) {
  const [open, setOpen] = useState(false)
  if (!data) return null
  return (
    <div className="mt-1">
      <button
        onClick={() => setOpen((o) => !o)}
        className="text-xs opacity-70 underline"
      >
        {open ? "▲" : "▼"} fn: {data.name}
      </button>
      {open && (
        <pre className="mt-1 text-xs bg-admin_neutral_1 border border-admin_bordered rounded p-2 overflow-x-auto whitespace-pre-wrap">
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  )
}

function MessageBubble({ msg }) {
  const cfg = ROLE_CONFIG[msg.role] || ROLE_CONFIG.system
  const ts = msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString() : null

  return (
    <div className={`flex flex-col ${cfg.align} gap-0.5`}>
      <div className={`px-3 py-2 max-w-[70%] ${cfg.bubble}`}>
        {msg.content && (
          <p className="text-sm whitespace-pre-wrap leading-relaxed">{msg.content}</p>
        )}
        {msg.functionCall && <FnCallBadge data={msg.functionCall} />}
      </div>
      {ts && (
        <span className="text-[10px] text-admin_text_secondary px-1">{ts}</span>
      )}
    </div>
  )
}

export default function TranscriptViewer({ session }) {
  const [showSystem, setShowSystem] = useState(true)
  const [showFnCalls, setShowFnCalls] = useState(true)

  if (!session) return null

  const messages = (session.messages || []).filter((m) => {
    if (m.role === "system" && !showSystem) return false
    if (m.functionCall && !showFnCalls) return false
    return true
  })

  return (
    <div className="flex flex-col h-full">
      {/* Filter bar */}
      <div className="flex items-center gap-4 px-4 py-2 border-b border-admin_bordered bg-admin_paper flex-shrink-0">
        <span className="text-xs font-medium text-admin_text_secondary">Filter:</span>
        <label className="flex items-center gap-1 text-xs cursor-pointer text-admin_text">
          <input type="checkbox" checked={showSystem} onChange={(e) => setShowSystem(e.target.checked)} className="accent-admin_primary" />
          System events
        </label>
        <label className="flex items-center gap-1 text-xs cursor-pointer text-admin_text">
          <input type="checkbox" checked={showFnCalls} onChange={(e) => setShowFnCalls(e.target.checked)} className="accent-admin_primary" />
          Function calls
        </label>
        <span className="ml-auto text-xs text-admin_text_secondary">{messages.length} messages</span>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-2 bg-admin_canvas">
        {messages.length === 0 && (
          <p className="text-sm text-admin_text_secondary text-center py-8">No messages match the current filter.</p>
        )}
        {messages.map((msg, i) => (
          <MessageBubble key={i} msg={msg} />
        ))}
      </div>
    </div>
  )
}
